// tslint:disable
/**
 * Ux
 * insightux admin api
 *
 * The version of the OpenAPI document: 0.62
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { useMutation, useRequest } from "redux-query-react";
import { createSelector } from '@reduxjs/toolkit';
import { useSelector } from 'react-redux';
import * as QueryString from 'query-string';
import { isEqual } from "lodash";
import * as runtime from '../runtime';
import { objectToHash } from "common/object-helper";
import { MarketResponseFromJSON, PostMarketRequestToJSON, } from '../models';
/**
 * Create Market Endpoint
 * Create Market
 */
export function createMarketRaw(requestParameters, requestConfig = {}) {
    let queryParameters = null;
    let queryString = "";
    const headerParameters = {};
    headerParameters['Content-Type'] = 'application/json';
    const { meta = {} } = requestConfig;
    meta.authType = ['bearer'];
    const config = {
        url: runtime.BASE_PATH + `/markets` + queryString,
        meta,
        update: requestConfig.update || {
            Markets: (prevValue, transformedValue) => {
                return { ...prevValue, ...transformedValue };
            }
        },
        force: requestConfig.force,
        options: requestConfig.options || {
            method: 'POST',
            headers: headerParameters,
        },
        body: PostMarketRequestToJSON(requestParameters.postMarketRequest),
        transform: requestConfig.transform ? requestConfig.transform : (body, text) => {
            const objResponse = MarketResponseFromJSON(body);
            if (body.id) {
                return { Markets: { [objResponse.id]: objResponse } };
            }
            if (body.data && body.total && requestConfig.queryKey) {
                return { Markets: { [requestConfig.queryKey]: objResponse } };
            }
            return {};
        }
    };
    config.queryKey = requestConfig.queryKey || `CreateMarket-${objectToHash(requestParameters)}`;
    return config;
}
/**
* Create Market Endpoint
* Create Market
*/
/**
 * Mutation hook to create a Client
 * @param customQueryConfig TypedQueryConfig options set here will override default options.
 * @returns [QueryState, RunMutation] queryState and an async call to upsert an array client
 */
export const useCreateMarket = (customQueryConfig) => {
    return useMutation((postMarketRequest, customQueryParam) => createMarketRaw({ postMarketRequest }, { ...customQueryConfig, meta: { ...customQueryConfig?.meta, ...customQueryParam } }));
};
export function createMarket(requestParameters, requestConfig) {
    return createMarketRaw(requestParameters, requestConfig);
}
/**
 * Delete Market
 * Delete Market
 */
export function deleteMarketRaw(requestParameters, requestConfig = {}) {
    if (requestParameters.id === null || requestParameters.id === undefined) {
        throw new runtime.RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling deleteMarket.');
    }
    let queryParameters = null;
    let queryString = "";
    const headerParameters = {};
    const { meta = {} } = requestConfig;
    meta.authType = ['bearer'];
    const config = {
        url: runtime.BASE_PATH + `/markets/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))) + queryString,
        meta,
        update: requestConfig.update || {
            Markets: (prevValue, transformedValue) => {
                const updateValue = { ...prevValue };
                delete updateValue[requestParameters.id];
                return updateValue;
            }
        },
        optimisticUpdate: requestConfig.optimisticUpdate || {
            Markets: (prevValue) => {
                const optimisticValue = { ...prevValue };
                delete optimisticValue[requestParameters.id];
                return optimisticValue;
            }
        },
        rollback: requestConfig.rollback || {
            Markets: (initialValue, currentValue) => {
                const rollbackValue = { ...currentValue };
                rollbackValue[requestParameters.id] = initialValue[requestParameters.id];
                return rollbackValue;
            }
        },
        force: requestConfig.force,
        options: requestConfig.options || {
            method: 'DELETE',
            headers: headerParameters,
        },
        body: queryParameters,
    };
    config.queryKey = requestConfig.queryKey || `DeleteMarket-${objectToHash(requestParameters)}`;
    return config;
}
/**
* Delete Market
* Delete Market
*/
/**
 * Mutation hook for deleting a Markets, with optimistic update and optimized rollback in case of failure.
 * @param customQueryConfig TypedQueryConfig options set here will override default options.
 * @returns [QueryState, RunMutation] queryState and an async call to delete a Markets
 */
export const useDeleteMarket = (customQueryConfig) => {
    return useMutation((id, customQueryParam) => deleteMarket({ id }, { ...customQueryConfig, meta: { ...customQueryConfig?.meta, ...customQueryParam } }));
};
export function deleteMarket(requestParameters, requestConfig) {
    return deleteMarketRaw(requestParameters, requestConfig);
}
/**
 * Get Markets
 */
export function getMarketsRaw(requestParameters, requestConfig = {}) {
    if (requestParameters.marketTypes === null || requestParameters.marketTypes === undefined) {
        throw new runtime.RequiredError('marketTypes', 'Required parameter requestParameters.marketTypes was null or undefined when calling getMarkets.');
    }
    let queryParameters = null;
    let queryString = "";
    queryParameters = {};
    if (requestParameters.marketTypes) {
        queryParameters['marketTypes'] = requestParameters.marketTypes;
    }
    queryString = `?${QueryString.stringify(queryParameters)}`;
    const headerParameters = {};
    const { meta = {} } = requestConfig;
    meta.authType = ['bearer'];
    const config = {
        url: runtime.BASE_PATH + `/markets` + queryString,
        meta,
        update: requestConfig.update || {
            Markets: (prevValue, transformedValue) => {
                return { ...prevValue, ...transformedValue };
            }
        },
        force: requestConfig.force,
        options: requestConfig.options || {
            method: 'GET',
            headers: headerParameters,
        },
        body: queryParameters,
        transform: requestConfig.transform ? requestConfig.transform : (body, text) => {
            const objResponse = body.map(MarketResponseFromJSON);
            return {
                Markets: objResponse.reduce((map, obj) => {
                    map[obj.id] = obj;
                    return map;
                }, {})
            };
        }
    };
    config.queryKey = requestConfig.queryKey || `GetMarkets-${objectToHash(requestParameters)}`;
    return config;
}
/**
* Get Markets
*/
/**
 * Use this selectors to get a record of all Array<MarketResponse>, with their ids as keys
 * @returns A record of Array<MarketResponse> object, with their ids as keys
 */
export const useMarketsRecordSelector = () => useSelector((state) => state.entities.Markets, isEqual);
const MarketsArraySelector = createSelector((state) => state.entities.Markets, (selectedSubState) => Object.keys(selectedSubState).map((id) => selectedSubState[id]));
/**
 * Use this selector to get a reference to a flat Array<MarketResponse>.
 * If you are doing transformation on this object, consider using useMarketsRecordSelector instead for performances
 * @returns An array containing all loaded Markets
 */
export const useMarketsArraySelector = () => useSelector(MarketsArraySelector, isEqual);
/**
 * Request hook for Array<MarketResponse>
 * @param customQueryConfig TypedQueryConfig options set here will override default options.
 * @returns an array containg the data, query status, and a call for refresh
 * (note : refresh shouldn't be necessary, update to the state should be handle by mutators)
 */
export const useGetMarkets = (requestParameters, customQueryConfig) => {
    const [querystate, forceRefresh] = useRequest(getMarketsRaw(requestParameters, customQueryConfig));
    return [
        useMarketsArraySelector(),
        querystate,
        forceRefresh
    ];
};
export function getMarkets(requestParameters, requestConfig) {
    return getMarketsRaw(requestParameters, requestConfig);
}
